module.exports = __webpack_public_path__ + "static/img/best-videos.3e72e7a1.png";